import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import useAdminProfile from '../../hooks/useAdminProfile';
import { isValidPayoutMonth, mobileListPath } from './settlementStatement.util';

/**
 * /mobile/settlement, /mobile/settlement/:payoutMonth — 이메일·푸시 공통 링크. 주소의 월은 정산월이다.
 * 화면을 그리지 않고 로그인 상점의 목록 또는 월 상세로 보낸다. 정산월이 올바르지 않으면 목록으로 보낸다.
 */
export default function SettlementEntryMobile() {
  const navigate = useNavigate();
  const { payoutMonth } = useParams();
  const { storeNo } = useAdminProfile();

  useEffect(() => {
    if (!storeNo) return;
    const listPath = mobileListPath(storeNo);
    navigate(isValidPayoutMonth(payoutMonth) ? `${listPath}/${payoutMonth}` : listPath, { replace: true });
  }, [navigate, storeNo, payoutMonth]);

  return null;
}
